"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
/**
 * StripeCheckout component renders a Stripe payment form for the shopping cart. It requires checkout data and an onApprove callback function as props. The component will render a message indicating that Stripe checkout is not yet available in this build.
 *
 * @param: checkoutData - An object containing the details of the checkout, such as total amount, currency, and shipping information.
 * @param: onApprove - A callback function that will be called when the payment is approved by the user. It receives the payment details as an argument.
 * @returns: A React component that renders a message about Stripe checkout availability.
 */
StripeCheckout.propTypes = {
    checkoutData: PropTypes.object.isRequired,
    onApprove: PropTypes.func.isRequired,
};
export function StripeCheckout(props) {
    return (_jsx("div", { className: "pix-cart-payment-method", children: _jsx("div", { children: _jsx("p", { children: "Stripe checkout is not yet available in this build." }) }) }));
}
export function renderStripeThankYou(orderData, config) {
    return (_jsxs("div", { children: [_jsx("h3", { children: "Thank you for your payment!" }), _jsx("p", { children: "Stripe checkout completed successfully." }), _jsx("pre", { style: { whiteSpace: 'pre-wrap', wordBreak: 'break-word' }, children: JSON.stringify(orderData, null, 2) })] }));
}
